import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    padding: 5px 0 4px 5px;
    width: 100%;
`

const Error = styled.p`
    color: ${({ $color }) => ($color ? $color : 'rgb(215, 69, 77)')};
    font-size: 14px;
    line-height: 150%;

    @media (max-width: 375px) {
        font-size: 12px;
    }
`

const ValidationError = ({ color, children }) => (
    <Container>
        <Error $color={color}>{children}</Error>
    </Container>
)

export default ValidationError
